module.exports = __webpack_public_path__ + "static/media/2-square-onhold.af019dcd.svg";